export const RESIZE = Symbol('RESIZE');
export const SCROLL = Symbol('SCROLL');
